import { Box, Stack, Text, Alert, Button, Skeleton, DeviceIcon } from '@citibox-panel/ui';
import type { UserDevice } from '@citibox-panel/api-client';
import { FieldRow } from './FieldRow';

export interface DeviceLayoutProps {
  device: UserDevice | null | undefined;
  isPending: boolean;
  isError: boolean;
  onRetry: () => void;
}

function DeviceHeader() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <DeviceIcon fontSize="small" />
      {/* TODO: i18n — copy en ES hasta Fase 1. */}
      {/* Bold section title, consistent with the bold field labels below. */}
      <Text variant="subtitle2" bold>
        Dispositivo
      </Text>
    </Box>
  );
}

// The device card owns loading, empty and error in isolation: a failure surfaces an
// inline retry here and never reaches the account card. "No device" is a valid empty
// state (200 with device:null), not an error.
export function DeviceLayout({ device, isPending, isError, onRetry }: DeviceLayoutProps) {
  return (
    <Stack spacing={0.5}>
      <DeviceHeader />
      {isPending ? (
        <Stack spacing={1}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} width="70%" />
          ))}
        </Stack>
      ) : isError ? (
        <Box>
          {/* TODO: i18n */}
          <Alert severity="error">No se pudieron cargar los datos del dispositivo.</Alert>
          <Box sx={{ mt: 1 }}>
            <Button variant="text" onClick={onRetry}>
              Reintentar
            </Button>
          </Box>
        </Box>
      ) : (
        // No telemetry (200 with an empty body, `device: null`, or `{}`) renders the same
        // labelled rows, with FieldRow falling each blank value back to an em dash — not a
        // separate empty state.
        <Box>
          {/* TODO: i18n */}
          <FieldRow label="VERSIÓN APP" value={device?.appVersion} />
          <FieldRow label="SISTEMA OPERATIVO" value={device?.os} />
          <FieldRow label="VERSIÓN S.O." value={device?.osVersion} />
          <FieldRow label="MODELO" value={device?.model} />
          <FieldRow label="OPERADOR" value={device?.carrier} />
        </Box>
      )}
    </Stack>
  );
}
